import React from 'react'
import ReactDOM from 'react-dom'
import App from './incentive_cart/containers/App'

const initCart = () => {
  const appNode = document.createElement('div')
  document.body.appendChild(appNode)
  ReactDOM.render(
    <App />,
    appNode
  )
}

const initIncentiveCart = () => {
  initCart()
}

export { initIncentiveCart }
